/** Generated by @gh/common callable client codegen. Do not edit manually. */

import type { CallableApiConfig, RouteTypeMap } from "@gh/common/callable-client";
import type { TellescopeBookAppointmentRequest, TellescopeBookAppointmentResponse, TellescopeFetchCustomerEventsRequest, TellescopeFetchCustomerEventsResponse, TellescopeForceSyncCustomerRequest, TellescopeForceSyncCustomerResponse, TellescopeGetAvailabilitySlotsRequest, TellescopeGetAvailabilitySlotsResponse, TellescopeImportConsultationBookingRequest, TellescopeImportConsultationBookingResponse, TellescopeManualSyncConsultationRequest, TellescopeManualSyncConsultationResponse, TellescopeSyncExistingCustomersRequest, TellescopeSyncExistingCustomersResponse, TellescopeTriggerConsultationSyncRequest, TellescopeTriggerConsultationSyncResponse } from "../../src/types";
import type { TellescopeEnsureClinicalAvailabilityFreshRequest, TellescopeEnsureClinicalAvailabilityFreshResponse, TellescopeGetUsersRequest, TellescopeGetUsersResponse, TellescopeLinkConsultantUserRequest, TellescopeLinkConsultantUserResponse, TellescopeListVendorSyncCollectionRequest, TellescopeListVendorSyncCollectionResponse, TellescopeSyncClinicalAvailabilitySlotsRequest, TellescopeSyncClinicalAvailabilitySlotsResponse, TellescopeTriggerCalendarEventResolveRequest, TellescopeTriggerCalendarEventResolveResponse, TellescopeTriggerDiscoverCalendarEventsRequest, TellescopeTriggerDiscoverCalendarEventsResponse, TellescopeTriggerDiscoverEndusersRequest, TellescopeTriggerDiscoverEndusersResponse, TellescopeTriggerDiscoverUsersRequest, TellescopeTriggerDiscoverUsersResponse, TellescopeTriggerEnduserResolveRequest, TellescopeTriggerEnduserResolveResponse, TellescopeTriggerUserResolveRequest, TellescopeTriggerUserResolveResponse } from "../../src/vendorSyncTypes";



export interface TellescopeRouteTypeMap extends RouteTypeMap {
  bookAppointment: {
    request: TellescopeBookAppointmentRequest;
    response: TellescopeBookAppointmentResponse;
  };
  ensureClinicalAvailabilityFresh: {
    request: TellescopeEnsureClinicalAvailabilityFreshRequest;
    response: TellescopeEnsureClinicalAvailabilityFreshResponse;
  };
  fetchCustomerEvents: {
    request: TellescopeFetchCustomerEventsRequest;
    response: TellescopeFetchCustomerEventsResponse;
  };
  forceSyncCustomer: {
    request: TellescopeForceSyncCustomerRequest;
    response: TellescopeForceSyncCustomerResponse;
  };
  getAvailabilitySlots: {
    request: TellescopeGetAvailabilitySlotsRequest;
    response: TellescopeGetAvailabilitySlotsResponse;
  };
  getUsers: {
    request: TellescopeGetUsersRequest;
    response: TellescopeGetUsersResponse;
  };
  importConsultationBooking: {
    request: TellescopeImportConsultationBookingRequest;
    response: TellescopeImportConsultationBookingResponse;
  };
  linkConsultantUser: {
    request: TellescopeLinkConsultantUserRequest;
    response: TellescopeLinkConsultantUserResponse;
  };
  listVendorSyncCollection: {
    request: TellescopeListVendorSyncCollectionRequest;
    response: TellescopeListVendorSyncCollectionResponse;
  };
  manualSyncConsultation: {
    request: TellescopeManualSyncConsultationRequest;
    response: TellescopeManualSyncConsultationResponse;
  };
  syncClinicalAvailabilitySlots: {
    request: TellescopeSyncClinicalAvailabilitySlotsRequest;
    response: TellescopeSyncClinicalAvailabilitySlotsResponse;
  };
  syncExistingCustomers: {
    request: TellescopeSyncExistingCustomersRequest;
    response: TellescopeSyncExistingCustomersResponse;
  };
  triggerCalendarEventResolve: {
    request: TellescopeTriggerCalendarEventResolveRequest;
    response: TellescopeTriggerCalendarEventResolveResponse;
  };
  triggerConsultationSync: {
    request: TellescopeTriggerConsultationSyncRequest;
    response: TellescopeTriggerConsultationSyncResponse;
  };
  triggerDiscoverCalendarEvents: {
    request: TellescopeTriggerDiscoverCalendarEventsRequest;
    response: TellescopeTriggerDiscoverCalendarEventsResponse;
  };
  triggerDiscoverEndusers: {
    request: TellescopeTriggerDiscoverEndusersRequest;
    response: TellescopeTriggerDiscoverEndusersResponse;
  };
  triggerDiscoverUsers: {
    request: TellescopeTriggerDiscoverUsersRequest;
    response: TellescopeTriggerDiscoverUsersResponse;
  };
  triggerEnduserResolve: {
    request: TellescopeTriggerEnduserResolveRequest;
    response: TellescopeTriggerEnduserResolveResponse;
  };
  triggerUserResolve: {
    request: TellescopeTriggerUserResolveRequest;
    response: TellescopeTriggerUserResolveResponse;
  };
}

export const tellescopeApiConfig = {
  gatewayName: "tellescope_default_gateway",
  routes: {
    bookAppointment: {
      gateway: "tellescope_default_gateway",
      action: "bookAppointment",
    },
    ensureClinicalAvailabilityFresh: {
      gateway: "tellescope_default_gateway",
      action: "ensureClinicalAvailabilityFresh",
    },
    fetchCustomerEvents: {
      gateway: "tellescope_default_gateway",
      action: "fetchCustomerEvents",
    },
    forceSyncCustomer: {
      gateway: "tellescope_default_gateway",
      action: "forceSyncCustomer",
    },
    getAvailabilitySlots: {
      gateway: "tellescope_default_gateway",
      action: "getAvailabilitySlots",
    },
    getUsers: {
      gateway: "tellescope_default_gateway",
      action: "getUsers",
    },
    importConsultationBooking: {
      gateway: "tellescope_default_gateway",
      action: "importConsultationBooking",
    },
    linkConsultantUser: {
      gateway: "tellescope_default_gateway",
      action: "linkConsultantUser",
    },
    listVendorSyncCollection: {
      gateway: "tellescope_default_gateway",
      action: "listVendorSyncCollection",
    },
    manualSyncConsultation: {
      gateway: "tellescope_default_gateway",
      action: "manualSyncConsultation",
    },
    syncClinicalAvailabilitySlots: {
      gateway: "tellescope_default_gateway",
      action: "syncClinicalAvailabilitySlots",
    },
    syncExistingCustomers: {
      gateway: "tellescope_default_gateway",
      action: "syncExistingCustomers",
    },
    triggerCalendarEventResolve: {
      gateway: "tellescope_default_gateway",
      action: "triggerCalendarEventResolve",
    },
    triggerConsultationSync: {
      gateway: "tellescope_default_gateway",
      action: "triggerConsultationSync",
    },
    triggerDiscoverCalendarEvents: {
      gateway: "tellescope_default_gateway",
      action: "triggerDiscoverCalendarEvents",
    },
    triggerDiscoverEndusers: {
      gateway: "tellescope_default_gateway",
      action: "triggerDiscoverEndusers",
    },
    triggerDiscoverUsers: {
      gateway: "tellescope_default_gateway",
      action: "triggerDiscoverUsers",
    },
    triggerEnduserResolve: {
      gateway: "tellescope_default_gateway",
      action: "triggerEnduserResolve",
    },
    triggerUserResolve: {
      gateway: "tellescope_default_gateway",
      action: "triggerUserResolve",
    },
  },
} as const satisfies CallableApiConfig<TellescopeRouteTypeMap>;
